import React from "react";
import { Card } from "../../../components/ui/Card";
import PropTypes from "prop-types";
import { useOpenModal } from "../../../hooks/useOpenModal";
import _ModalRCSErrors from "./modal/_ModalRCSErrors";

const CardRCSDashboard = ({ data = [], loading = false }) => {
  const { onOpen, visible, onClose } = useOpenModal();
  const CARDS_DATA = [
    {
      title: "Enviados",
      icon: "chat_bubble",
      text: "text-gray-600",
      value: data?.i_sent ?? 0,
      details: null,
    },
    {
      title: "Leidos",
      icon: "done_all",
      text: "text-blue-600",
      value: data?.i_readed ?? 0,
      details: null,
    },
    {
      title: "Entregados",
      icon: "check",
      text: "text-blue-600",
      value: data?.i_delivered ?? 0,
      details: null,
    },
    {
      title: "Respuestas",
      icon: "reply",
      text: "text-green-600",
      value: data?.i_replies ?? 0,
      details: null,
    },
    {
      title: "Fallidos",
      icon: "report_problem",
      text: "text-red-600",
      value: data?.i_invalid ?? 0,
      details: null,
    },
    {
      title: "Fallback",
      icon: "merge",
      text: "text-purple-600",
      value: data?.i_fallback ?? 0,
      details: null,
    },
    {
      title: "Por procesar",
      icon: "pending",
      text: "text-yellow-600",
      value: data?.i_pending ?? 0,
      details: null,
    },
    {
      title: "Errores",
      icon: "error",
      text: "text-orange-600",
      value: data?.i_errors ?? 0,
      details: onOpen,
    },
    {
      title: "Otros",
      icon: "question_mark",
      text: "text-gray-600",
      value: data?.other_actions ?? 0,
      details: null,
    },
  ];

  return (
    <>
      {CARDS_DATA.map((card, index) => (
        <Card
          key={index}
          title={card.title}
          icon={card.icon}
          text={card.text}
          loading={loading}
          value={Number(card.value)}
          typeIcon="outlined"
          details={card.details}
        />
      ))}

      <_ModalRCSErrors
        title="Errores en RCS"
        visible={visible}
        onClose={onClose}
      />
    </>
  );
};

CardRCSDashboard.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default CardRCSDashboard;
